import EmailList from "./EmailList";
export default function TempMailGen({ inboxProps }) {
  return <EmailList {...inboxProps} title="Временная почта" query="" onQuery={() => {}} />;
}
